import { useNavigate } from "react-router-dom";
import AppButton from "../../components/AppButton";
import { dashboardOptions } from "../../data";

const Dashboard = () => {
  const navigate = useNavigate();

  const handleNavigate = (item) => {
    navigate(item.path, {
      state: {
        ...item,
        type: item.title,
      },
    });
  };

  return (
    <div className="tcl-personal-page">
      <div className="tcl-personal-wrapper">
        <div className="btn-wrapper">
          {dashboardOptions.map((btn, index) => (
            <AppButton
              key={index}
              title={btn.label}
              onClick={() => handleNavigate(btn)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
